export default __webpack_public_path__ + "static/media/FOTO-04.47ec0063.jpg";